export default "__VITE_ASSET__D1SB1c_U__"